import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';

export interface IManual {
  id: string;
  labelKey: string;
  url: string;
}

const URL_BASE_MANUALES = 'https://cloud.secihti.mx/1';

@Component
export default class ManualesModalComponent extends Vue {
  @Prop({ default: 'modal-manuales' })
  id: string;

  public get currentLanguage(): string {
    return this.$store.getters.currentLanguage;
  }

  public get manuales(): IManual[] {
    return [
      {
        id: 'guia-2fa',
        labelKey: 'manuales.documentos.guia2fa',
        url: `${URL_BASE_MANUALES}/Guia_2FA_acceso_sistemas_SECIHTI_${this.sufijoIdioma}.pdf`,
      },
    ];
  }

  private get sufijoIdioma(): string {
    return this.currentLanguage === 'en' ? 'EN' : 'ES';
  }

  public closeModal(): void {
    this.$bvModal.hide(this.id);
  }
}
